import React from 'react';

import CardsSkeleton from 'components/skeletons/CardsSkeleton';
import { useQueryGetCountries } from 'Customers/hooks/useCustomers';

import InputsSectionContainer from '../InputsSectionContainer/InputsSectionContainer';
import NewCustomerBasicInfoInputs from '../NewCustomerBasicInfo/NewCustomerBasicInfoInputs';
import NewCustomerBillingAddressInfoInputs from '../NewCustomerBasicInfo/NewCustomerBillingAddressInfoInputs';

const EditCustomerBasicInfo = (formik) => {
  const { isLoading, data } = useQueryGetCountries();
  return (
    <section className='w-100'>
      <h4 className='subtitle font-size-20 mt-7 mb-5'>Let&apos;s start with some of the basic information</h4>
      {isLoading && <CardsSkeleton col={12} height={350} num={1} />}
      {!isLoading && (
        <>
          <InputsSectionContainer
            title='Basic Info'
            subTitle='Define some basic details about the company'
            className='mb-3'
          >
            <NewCustomerBasicInfoInputs formik={formik} countries={data?.data?.items} edit />
          </InputsSectionContainer>
          <InputsSectionContainer
            title='Billing Address Info'
            subTitle='Define fields that will accommodate the companies tax requirements'
            className='mb-3'
          >
            <NewCustomerBillingAddressInfoInputs formik={formik} accountType={formik.values.accountType} />
          </InputsSectionContainer>
        </>
      )}
    </section>
  );
};

export default EditCustomerBasicInfo;
